import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpand45: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"expand-45, enlarge"} maskId="square-filled-radius-0-stroke-1-IconExpand45"><path fillRule="evenodd" clipRule="evenodd" d="M13 3H21V11H20V4.70711L13.5 11.2071L12.7929 10.5L19.2929 4H13V3ZM11.2071 13.5L4.70711 20H11V21H3V13H4V19.2929L10.5 12.7929L11.2071 13.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconExpand45;
